export default {
	common: {
		apply: 'Apply',
		cancel: 'Cancel',
	},
	validation: {
		patternMismatch: 'This field contains invalid characters',
		rangeOverflow: 'This number is too high',
		rangeUnderflow: 'This number is too low',
		stepMismatch: 'This number does not fit the allowed step size',
		tooLong: 'This text is too long',
		tooShort: 'This text is too short',
		typeMismatch: 'This value is not of the right type',
		valueMissing: 'This field cannot be empty',
	},
	zdsAdvancedSelect: {
		noResults: 'No results',
		deleteItemLabel: 'Delete Item',
		clearInputLabel: 'Clear input',
		closeSelectionLabel: 'Close item selection',
	},
	zdsAppbar: {
		searchPlaceholder: 'Search',
	},
	zdsCalendar: {
		time: 'Time',
		previousMonthLabel: 'Previous month',
		nextMonthLabel: 'Next month',
	},
	zdsContentReveal: {
		showLess: 'Show less',
		showMore: 'Show more',
	},
	zdsInputDate: {
		invalidDate: 'This is not a valid date ({{format}})',
		dateTooEarly: 'The date cannot be before {{minDate}}',
		dateTooLate: 'The date cannot be after {{maxDate}}',
		dateNotAvailable: 'The selected date is not available',
		dateCannotBeHoliday: 'The date cannot be a national holiday',
		dateCannotBeInWeekend: 'The date cannot be on the weekend',
		openCalendarLabel: 'Open calendar',
	},
	zdsNavigation: {
		skipToContent: 'Skip to main content',
	},
	zdsPagination: {
		ariaLabel: 'Page navigation',
		ariaNextLabel: 'Next page',
		ariaPreviousLabel: 'Previous page',
		ariaPagePrefix: 'Page {{pageIndex}}',
	},
	zdsUpload: {
		dropAFileHere: 'Drop a file here',
		or: 'or',
		selectAFile: 'select a file',
		fileSelected: 'file selected',
		filesSelected: 'files selected',
		maxFilesReached: 'Reached the maximum number of files',
		validation: {
			fileSizeExceeded: 'File size ({{filesize}} MB) exceeds the maximum: {{maxFilesize}} MB',
			fileTypeNotSupported: 'File type is not supported, use: {{fileTypes}}',
			responseError: 'Something went wrong when uploading, try again later',
			maxOneFile: 'You can only select 1 file',
			maxFilesExceeded: 'You can only select {{maxFiles}} files',
			fileSizeTotalExceeded:
				'The total file size ({{totalFileSize}} MB) exceeds the maximum of {{maxTotalFileSize}} MB',
			badFileResponse: 'Something went wrong when uploading',
		},
		labels: {
			download: 'Download file',
			delete: 'Delete file',
		},
	},
	zdsInputRecipient: {
		invalidEmail: '"{{value}}" is not a valid email address',
		removeChipLabel: 'Remove recipient',
	},
	zdsVideo: {
		playLabel: 'Play video',
	},
	zdsTabs: {
		labels: {
			scrollLeft: 'Scroll Left',
			scrollRight: 'Scroll Right',
		},
	},
	zdsTab: {
		moreTabsLabel: 'Close Tab',
	},
	zdsSideSheet: {
		labels: {
			collapse: 'Collapse side menu',
			resize: 'Resize menu',
		},
	},
	zdsNavigationPanel: {
		backLabel: 'Go back',
		closeLabel: 'Close',
	},
	zdsInputTime: {
		clockLabe: 'Open time suggestions',
	},
	zdsInputPassword: {
		showPasswordLabel: 'Show password',
		hidePasswordLabel: 'Hide Password',
	},
	zdsInputContentContainer: {
		rejectLabel: 'Reject',
		acceptLabel: 'Accept',
		clearLabel: 'Clear input',
	},
	zdsDrawer: {
		closeLabel: 'Close',
	},
	zdsDataTable: {
		sortLabel: 'Sort table',
	},
	zdsChip: {
		deleteLabel: 'Delete Chip',
	},
	zdsCarousel: {
		closeFullscreen: 'Close fullscreen mode',
		slideLeftLabel: 'Slide left',
		slideRightLabel: 'Slide Right',
	},
};
